module.exports = __webpack_public_path__ + "static/media/example-work08.1ae035f0.jpg";